import xhrModule from '../xhrModule.js'

let editableReferencesDeleter = {
	queue: [],

	addToQueue: function (obj) {
		this.queue.push(obj)
	},

	deleteItems: function (callback, form) {
		// no editable references to delete
		if (this.queue.length === 0) callback(form)

		// post the deletion of all editable references and notify the form when we are done
		for (var i = this.queue.length - 1; i >= 0; i--) {
			var json = JSON.stringify(this.queue[i])
			var url = '/cms/api/instances/save'
			xhrModule.post(url, json, function () {
				// deletion completed
			})

			if (i === 0) {
				callback(form)
			}
		}
	},

	clearQueue: function () {
		this.queue = []
	}
}

export default editableReferencesDeleter
